import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import cx from 'classnames';
import { ControlLabel } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Card.css';
import {
  normalizeCard,
  normalizeMonth,
  normalizeYear,
  normalizeCVV,
} from './normalize';

// Helper
import PopulateData from '../../../helpers/populateData';

// Cards Logo Image
import creditCardLogo from './credit-card-logos.png';
import poweredByStripe from './powered_by_stripe.png';

// Locale
import messages from '../../../locale/messages';
import Button from '../../../components_new/common/FormComponents/Button';
import { View, Whitespace, Text } from '../../../components_new/common';
import Input from '../../../components_new/common/FormComponents/InputStyle';
import Select from '../../../components_new/addListing/Select';
import { observer } from 'mobx-react';
import { observable, action, computed, runInAction } from 'mobx';
import validate from './validate';
import { getp } from '../../../helpers/getProp';
import axios from 'axios';
import AddressSelect from '../../../components_new/addresses/AddressSelect';

@observer
class Card extends Component {
  @observable number = '';
  @observable name = '';
  @observable month = '';
  @observable year = '';
  @observable cvv = '';
  @observable address = '';
  @observable errors = {};

  static propTypes = {
    formatMessage: PropTypes.func,
    paymentType: PropTypes.number,
  };

  static defaultProps = {};

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    let now = new Date();
    let currentYear = now.getFullYear();
    let years = PopulateData.generateData(currentYear, currentYear + 10);
    let months = PopulateData.generateData(0, 11);
    this.setState({
      lookupData: {
        years: years,
        months: months,
      },
    });
  }

  @action.bound
  async save() {
    const errs = this.getErrors();
    this.errors = errs;
    if (errs.count === 0) {
      const res = await axios.post('/stripe-add-card', {
        cardDetails: {
          name: this.name,
          number: this.number,
          exp_month: this.month,
          exp_year: this.year,
          cvc: this.cvv,
          address_line1: this.address.street,
          address_line2: this.address.buildingName,
          address_city: this.address.city,
          address_state: this.address.state,
          address_zip: this.address.zipcode,
          address_country: 'USA',
        },
      });
      if (res && res.status === 200) {
        this.props.onSave && this.props.onSave(res.data.newSource);
      }
    }
  }

  @action.bound
  setNumber(number) {
    const newNum = normalizeCard(number);
    this.number = newNum;
  }
  @action.bound
  setName(name) {
    this.name = name;
  }
  @action.bound
  setMonth(month) {
    this.month = month;
  }
  @action.bound
  setYear(year) {
    this.year = year;
  }
  @action.bound
  setCvv(cvv) {
    this.cvv = normalizeCVV(cvv);
  }

  @action.bound
  handleAddressChanged(addr) {
    if (addr && addr.length > 0) {
      this.address = addr[0];
    } else {
      this.address = {};
    }
  }

  @action.bound
  getErrors() {
    const val = validate({
      paymentType: 2,
      name: this.name,
      month: this.month,
      year: this.year,
      cvv: this.cvv,
      number: this.number,
      street: this.address.street,
    });
    return val;
  }

  render() {
    const { lookupData } = this.state;
    const { formatMessage } = this.props.intl;

    return (
      <View>
        <View className="b-1 b-coolGrayLightest p-mxx f f-rows brad-m f-start-stretch">
          <View className="f f-rows f-start-stretch">
            <Text error>{getp(this.errors, 'name.defaultMessage', '')}</Text>
            <Input
              name="name"
              placeholder={formatMessage(messages.fullName)}
              value={this.name}
              onChange={e => this.setName(e.target.value)}
            />
          </View>
          <Whitespace smaller />
          <View className="f f-columns f-between-center ">
            <View className="f-1">
              <Text error>
                {getp(this.errors, 'number.defaultMessage', '')}
              </Text>
              <Input
                name="cardNumber"
                placeholder={formatMessage(messages.cardNumber)}
                value={this.number}
                onChange={e => this.setNumber(e.target.value)}
              />
            </View>
            <View className="w-100 ml-m">
              <Text error>{getp(this.errors, 'cvv.defaultMessage', '')}</Text>
              <Input
                name="cvv"
                placeholder={formatMessage(messages.cvv)}
                value={this.cvv}
                onChange={e => this.setCvv(e.target.value)}
              />
            </View>
          </View>
          <Whitespace smaller />
          <View>
            <View className="f f-columns f-sc">
              <View>
                <ControlLabel>
                  <FormattedMessage {...messages.cardExpires} />
                </ControlLabel>
              </View>
              <View className="ml-m mr-sx w-100">
                <Text error>
                  {getp(this.errors, 'month.defaultMessage', '')}
                </Text>

                <Select
                  onChange={e => this.setMonth(e.target.value)}
                  name="expiryDate"
                >
                  <option value="">{formatMessage(messages.expiryDate)}</option>
                  {lookupData.months.map((item, key) => {
                    return (
                      <option
                        key={key}
                        value={item < 9 ? '0' + (item + 1) : item + 1}
                      >
                        {item < 9 ? '0' + (item + 1) : item + 1}
                      </option>
                    );
                  })}
                </Select>
              </View>
              <View className="w-100">
                <Text error>
                  {getp(this.errors, 'year.defaultMessage', '')}
                </Text>

                <Select
                  name="expiryYear"
                  normalize={normalizeYear}
                  onChange={e => this.setYear(e.target.value)}
                >
                  <option value="">{formatMessage(messages.expiryYear)}</option>
                  {lookupData.years.map((item, key) => {
                    return (
                      <option key={key} value={item}>
                        {item}
                      </option>
                    );
                  })}
                </Select>
              </View>
            </View>
          </View>
          <Whitespace />
          <View>
            <Text h6>Billing Address</Text>
            <Text error>{getp(this.errors, 'address', '')}</Text>
            <View>
              <AddressSelect
                onSelectionChanged={this.handleAddressChanged}
                single
              />
            </View>
          </View>
          <View className="f f-columns f-between-center">
            <View className="">
              <img src={creditCardLogo} className="h-40 w-150" />
            </View>
            <View className="">
              <img src={poweredByStripe} className="h-40 w-150" />
            </View>
          </View>
        </View>
        <Button primary mt={3} onClick={this.save} type="button">
          Save
        </Button>
      </View>
    );
  }
}

const mapState = state => ({});

const mapDispatch = {};

export default injectIntl(
  withStyles(s)(
    connect(
      mapState,
      mapDispatch,
    )(Card),
  ),
);



// WEBPACK FOOTER //
// ./src/components/Booking/Card/Card.js